document.addEventListener('DOMContentLoaded', function () {

  /* Mobile menu toggle */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      nav.style.display = open ? 'block' : '';
      menuToggle.setAttribute('aria-expanded', open);
    });
  }

  /* Search panel toggle */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }
  if (searchClose && searchPanel) {
    searchClose.addEventListener('click', function () {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
    });
  }

  /* Cart drawer */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartToggles = document.querySelectorAll('[data-cart-toggle]');
  var cartCloses = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    renderCartDrawer();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  cartToggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  cartCloses.forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });

  function renderCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var itemsEl = document.getElementById('CartDrawerItems');
        var subtotalEl = document.getElementById('CartDrawerSubtotal');
        var countEls = document.querySelectorAll('[data-cart-count]');

        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        countEls.forEach(function (el) { el.textContent = cart.item_count; });

        if (!itemsEl) return;
        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p>Votre panier est vide.</p>';
          return;
        }
        itemsEl.innerHTML = cart.items.map(function (item) {
          return (
            '<div class="cart-drawer__item" style="display:flex;gap:12px;margin-bottom:16px;">' +
              (item.image ? '<img src="' + item.image + '" width="64" style="object-fit:cover;">' : '') +
              '<div><p style="margin:0 0 4px;font-size:14px;">' + item.product_title + '</p>' +
              '<p style="margin:0;font-size:13px;opacity:.6;">' + item.quantity + ' &times; ' + formatMoney(item.price) + '</p></div>' +
            '</div>'
          );
        }).join('');
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2) + ' DH';
  }

  /* Add to cart (AJAX) */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var btn = productForm.querySelector('[data-add-to-cart]');
      if (btn) btn.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) btn.removeAttribute('disabled');
          openCart();
        })
        .catch(function () {
          if (btn) btn.removeAttribute('disabled');
          productForm.submit();
        });
    });
  }

  /* Product gallery thumbnails */
  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
    });
  });

  /* Product option buttons -> hidden select -> sync price/availability */
  var variantSelect = document.querySelector('[data-product-variant-select]');
  document.querySelectorAll('[data-option-index]').forEach(function (group) {
    group.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        syncVariant();
      });
    });
  });

  function syncVariant() {
    if (!variantSelect) return;
    var selectedValues = [];
    document.querySelectorAll('[data-option-index]').forEach(function (group) {
      var active = group.querySelector('.is-selected');
      if (active) selectedValues.push(active.getAttribute('data-option-value'));
    });
    var options = Array.from(variantSelect.options);
    var match = options.find(function (opt) {
      var title = opt.textContent.split(' - ')[0].trim();
      return selectedValues.every(function (v) { return title.indexOf(v) !== -1; });
    });
    if (match) {
      variantSelect.value = match.value;
      var addBtn = document.querySelector('[data-add-to-cart]');
      var addText = document.querySelector('[data-add-to-cart-text]');
      var available = match.getAttribute('data-available') === 'true';
      if (addBtn) addBtn.toggleAttribute('disabled', !available);
      if (addText) addText.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    }
  }
});
